export class MessageTemplate
{
	messageTemplateId: number;
	createDate: Date;
	lastUpdate: Date;
	name: String;
	description: String;
	subject: String;
	message: String;
}
